import React, { Component } from "react";
import { alert, GET, PUT, loading, Navbar, profile, required, float } from "../../components/CustomComponent.js";
import Footer from "../../components/Footer.js";
import "bootstrap/dist/css/bootstrap.min.css";

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: profile?.uid || "",
      full_name: "",
      phone: "",
      role_id: "",
      email: "",
      password: "",
      confirm_password: "",
      is_active: false,
      is_2fa: false,
      is_mismatch_limit_approved: false,
      broker_id: "",

      user_type: "",
      is_phone: false,
    };
  }

  componentDidMount() {
    loading(false)
  }
  Update = async () => {
    const {
      uid,
      full_name,
      phone,
      role_id,
      email,
      password,
      confirm_password,
      is_active,
      is_2fa,
      is_mismatch_limit_approved,
      user_type,
      broker_id,
    } = this.state;
    if (!password) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่านใหม่");
      return;
    }
    if (password !== confirm_password) {
      alert("", "warning", "แจ้งเตือน", "รหัสผ่านไม่ตรงกัน");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "ยืนยันการส่งข้อมูล",
        "คุณต้องยืนยันการส่งข้อมูลใช่หรือไม่?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let body = {
        full_name,
        phone,
        role_id,
        email,
        user_type: user_type.replaceAll(" ", "_"),
        password,
        is_active,
        is_2fa,
        is_mismatch_limit_approved,
        broker_id: broker_id || null,
      };
      console.log(body)
      let result = await PUT("v1/admin/users/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  render() {
    const { uid,
      full_name,
      phone,
      role_id,
      email,
      password,
      confirm_password,
      is_active,
      is_2fa,
      is_mismatch_limit_approved,
      user_type,
      broker_id,is_phone } = this.state;

    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="row d-flex justify-content-center mx-0">
         <div className="col-12 col-sm-11 col-md-10 col-lg-2 col-xl-2 pt-5 mt-3 d-none d-lg-block">
          {/* ชื่อผู้ใช้ */}
          <div className="d-flex align-items-center text-start">
            <span className="bg-orange text-dark me-1 wpx-50 hpx-50 text-24 rounded-circle d-flex align-items-center justify-content-center">
              ลค
            </span>
            <div className="px-2 ">
              <div className="text-14 fw-bold">{profile?.full_name || "ลูกค้าทั่วไป"}</div>
              <div className="text-12 text-dark" style={{ marginTop: -2 }}>
                {profile?.phone || "-"}
              </div>
            </div>
          </div>
          {/* เมนู */}
          <div className="py-3">
            <a href="/profile" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf007"}</span>บัญชีของฉัน</div>
            </a>
            <a href="/address" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf015"}</span>ที่อยู่ของฉัน</div>
            </a>
            <a href="/change-password" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf084"}</span>เปลี่ยนรหัสผ่าน</div>
            </a>
            <a href="/transaction" className="d-flex justify-content-between pt-2 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
              <div className="d-flex"><span className="icon me-2">{"\uf570"}</span>การซื้อของฉัน</div>
            </a>
          </div>
        </div>
        <div className="col-12 col-sm-11 col-md-10 col-lg-9 col-xl-7 col-xxl-6 my-4 px-3 min-vh-100">
          <h4 className="fw-bold mb-3">เปลี่ยนรหัสผ่าน</h4>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="d-flex mb-3">
              <div className="wpx-120 mt-2">รหัสผ่านใหม่</div>
              <input
                type="text"
                className="form-control"
                placeholder="รหัสผ่านใหม่..."
                onChange={(e) => {
                  this.setState({ password: e.target.value });
                }}
                value={password}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-120 mt-2">ยืนยันรหัสผ่านใหม่</div>
              <input
                type="text"
                className="form-control"
                placeholder="ยืนยันรหัสผ่านใหม่..."
                onChange={(e) => {
                  this.setState({ confirm_password: e.target.value });
                }}
                value={confirm_password}
              />
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-dark px-4" onClick={() => {this.Update()}}>บันทึก</button>
            </div>
          </div>
        </div>
      </div>
        
      <Footer />
      </div>
    );
  }
}